import type { RemoveCompanyExternalLinkPayload } from '@/api/v4/organization-external-links.api';
import { removeCompanyExternalLink } from '@/api/v4/organization-external-links.api';
import { QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { captureExceptionSafely } from '@/helpers/capture-exception-safely';
import { useCompanyFetchMode } from '../company-fetch-context';
import { useTranslation } from 'react-i18next';

export const useRemoveCompanyExternalLink = () => {
  const { t } = useTranslation('default');
  const queryClient = useQueryClient();
  const fetchMode = useCompanyFetchMode();

  return useMutation({
    mutationFn: async ({
      companyId,
      linkId,
    }: RemoveCompanyExternalLinkPayload) => {
      return removeCompanyExternalLink({ companyId, linkId });
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          QueryKey.CompanyExternalLinks,
          fetchMode,
          variables.companyId,
        ],
      });
    },
    onError: (error: Error) => {
      notify({
        message: t`unknownError`,
      });
      captureExceptionSafely(error);
    },
  });
};
